import * as React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useParams } from "react-router-dom";
import NotFoundPage from "pages/NotFoundPage";

type Props = {
  children: JSX.Element[] | JSX.Element;
};

export default function Layout(props: Props) {
  const { portalId } = useParams();
  if (portalId === undefined) return <NotFoundPage />;

  return (
    <div className="d-flex flex-column min-vh-100 bg-primary">
      <Header portalId={portalId} />
      <main className="flex-grow-1 d-flex flex-column">{props.children}</main>
      <Footer />
    </div>
  );
}
